export default __webpack_public_path__ + "static/media/9b557b18a7c5464c57adb0df0dbe1ea4.svg";